import { DEFAULT_PAGE_SIZE } from '@atlassian/jira-admin-screens-services/src/common/constants.tsx';
import type { ScreensFilter } from '@atlassian/jira-admin-screens-services/src/services/screens-service/types.tsx';

const calculateMaximumPage = (pageSize: number = DEFAULT_PAGE_SIZE, totalScreens = 0): number =>
	Math.ceil(totalScreens / pageSize);

export const extractAnalyticsAttributes = (
	filter: ScreensFilter,
	totalScreens: number,
): {
	[key: string]: string | number | boolean | undefined;
} => ({
	currentPage: filter.pageNumber,
	maximumPage: calculateMaximumPage(filter.pageSize, totalScreens),
	pageSize: filter.pageSize,
	total: totalScreens,
});
